<oms-simple-sidebar
  class="my-profile-sidebar"
  (sidebarClosed)="layoutService.hideProfileSidebar()"
  [sidebarVisible]="visible()"
  title="Το προφίλ μου"
>
  <ng-container *ngIf="profile; else noProfileFound">
    <oms-card class="wrapper-card-profile" [hasBorder]="false">
      <div class="profile-header">
        <div class="profile flex flex-column justify-content-center">
          <div class="avatar flex justify-content-center">
            <p-avatar [image]="avatarBase64" shape="circle" size="xlarge"></p-avatar>
          </div>
          <div class="name text-center">
            {{ profile.firstName || 'Δεν βρέθηκε όνομα' }}
            {{ profile.lastName || '' }}
          </div>
          <div class="position text-center">
            <div *ngIf="profile.groups && profile.groups.length > 0; else noGroups">
              <div *ngFor="let group of profile.groups" class="group-item">
                {{ group }}
              </div>
            </div>
            <ng-template #noGroups>
              <span>Δεν βρέθηκαν ομάδες</span>
            </ng-template>
          </div>
        </div>

        <div class="first-row-actions justify-content-center flex">
          <div class="signout">
            <p-button
              [outlined]="true"
              severity="danger"
              icon="pi pi-power-off"
              iconPos="left"
              label="Έξοδος"
              (click)="signOut()"
              class="signout-btn p-button-danger"
            ></p-button>
          </div>
        </div>
      </div>

      <div class="profile-main-content">
        <div class="data">
          <oms-list-item-simple-data
            class="padding-top flex"
            [informationData]="profile.email || 'Δεν βρέθηκε email'"
            [greyTitle]="'Email'"
            avatarIcon="pi pi-envelope"
          ></oms-list-item-simple-data>
          <oms-list-item-simple-data
            class="padding-top flex"
            [informationData]="profile.afm || 'Δεν βρέθηκε ΑΦΜ'"
            [greyTitle]="'ΑΦΜ'"
            avatarIcon="pi pi-id-card"
          ></oms-list-item-simple-data>

          <oms-list-item-simple-data
            class="padding-top flex"
            [informationData]="'ID: ' + profile.userId"
            [greyTitle]="'Αναγνωριστικό Χρήστη'"
            avatarIcon="pi pi-hashtag"
          ></oms-list-item-simple-data>

          <!-- Active Subscription Info - Only visible to Company Owner -->
          <div *ngIf="hasActiveSubscription && subscription && isCompanyOwner" class="subscription-info-section padding-top">
            <div class="subscription-row flex align-items-center justify-content-between">
              <oms-list-item-simple-data
                class="flex flex-1"
                [informationData]="
                  (subscription.status === 'active'
                    ? 'Ενεργή'
                    : subscription.status === 'trialing'
                    ? 'Δοκιμαστική'
                    : subscription.status === 'past_due'
                    ? 'Εκκρεμής Πληρωμή'
                    : subscription.status) || 'Άγνωστη'
                "
                [greyTitle]="'Συνδρομή'"
                avatarIcon="pi pi-check-circle"
              ></oms-list-item-simple-data>
              <div class="subscription-action ml-3">
                <p-button
                  label="Διαχείριση"
                  icon="pi pi-cog"
                  (onClick)="navigateToSubscription()"
                  styleClass="p-button-outlined p-button-sm"
                ></p-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </oms-card>
  </ng-container>
  <ng-template #noProfileFound>
    <oms-card class="wrapper-card-profile" [hasBorder]="false">
      <div class="profile-header">
        <div class="no-profile-placeholder p-3 text-center">
          <p class="mb-4">Δεν βρέθηκαν στοιχεία προφίλ</p>
        </div>
        <div class="first-row-actions justify-content-center flex">
          <div class="signout">
            <p-button
              [outlined]="true"
              severity="danger"
              icon="pi pi-power-off"
              iconPos="left"
              label="Έξοδος"
              (click)="signOut()"
              class="signout-btn p-button-danger"
            ></p-button>
          </div>
        </div>
      </div>
    </oms-card>
  </ng-template>
</oms-simple-sidebar>
